(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('PrintLabelDialogController', PrintLabelDialogController);

	PrintLabelDialogController.$inject = ['$mdDialog', 'wine', '$window', 'lodash', '$log', '$scope', '$timeout', '$http', 'Rollbar', 'Utils'];

	function PrintLabelDialogController($mdDialog, wine, $window, lodash, $log, $scope, $timeout, $http, Rollbar, Utils) {

		/* jshint validthis: true */
		var self = this;

		self.wine = wine;

		self.settings = {
			isFindingPrinters: false,
			printers: null,
			selectedPrinter: null,
			qty: lodash.get(wine, 'cellar.qty', 1) // how many to print
		};

		self.error = {
			message: null
		};

		self.close = close;
		self.printBigLabel = printBigLabel;
		self.printSmallLabel = printSmallLabel;
		self.printBottleTags = printBottleTags;
		self.retryPrinters = retryPrinters;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			initializePrinters();
		}

		function close(){
			return $mdDialog.hide();
		}

		function retryPrinters(){
			self.error.message = null;
			self.settings.isFindingPrinters = true;

			// add timeout otherwise the prior error message would show too fast again and might appear to not work even though it did
			$timeout(setPrinter, 1000);
		}

		function setPrinter(){

			$window.dymo.label.framework.getPrintersAsync().then(function (printers) {
				// Successful result, printers variable has a list of all supported by the DYMO Label Framework

				$scope.$apply(function(){

					self.settings.isFindingPrinters = false;

					$log.debug('Printers found', printers);

					// look for a connected printer
					var printer = lodash.findWhere(printers, {
						"isConnected": true,
						"printerType": 'LabelWriterPrinter'
					});

					if (lodash.isEmptyOrNull(printer)) {
						$log.debug('Did not find a connected printer.');
						self.error.message = "We found a printer but it doesn't appear to be connected. Please make sure it's connected and try again.";
						return false;
					}

					$log.debug('Found printer', printer.name);

					self.settings.selectedPrinter = printer.name;
				});

			}).thenCatch(function (err) {

				$scope.$apply(function() {
					self.settings.isFindingPrinters = false;

					$log.error('Printers error', err);

					self.error.message = 'No DYMO printers are installed. Please install a DYMO printer or review our printing section on the Help screen.';
				});
			});
		}

		function initializePrinters(){

			self.settings.isFindingPrinters = true;

			try {
				$window.dymo.label.framework.trace = 1;
				$window.dymo.label.framework.init(function() {

					$log.debug('Dymo initialized...');

					setPrinter();

				});

			} catch (err){

				self.settings.isFindingPrinters = false;

				self.error.message = 'No DYMO printers are installed. Please install a DYMO printer or review our printing section on the Help screen.';
			}
		}

		function printBottleTags(){
			// print the front tag
			$http.get('/templates/labels/bottleTagFront.html').then(function(response) {

				return _printLabel(response.data, function(label, id){

					$log.debug('Building label for front bottle tag.', id);

					var name = lodash.get(self.wine, 'name');
					var producer = lodash.get(self.wine, 'producer.name');
					var vintage = lodash.get(self.wine, 'vintage');

					if (vintage && vintage > 0){
						label.setObjectText('VINTAGE', vintage + '');
					} else {
                        label.setObjectText('VINTAGE', '');
					}

					label.setObjectText("PRODUCER", _newlineOn(15, producer));

					label.setObjectText("NAME", _newlineOn(15, name));

					return label;
				});

			}).then(function(){
				// print the back tag

				$http.get('/templates/labels/bottleTagBack.html').then(function(response) {

					_printLabel(response.data, function(label, id){

						$log.debug('Building label for back bottle tag.', id);

						var drinkAfter = lodash.get(self.wine, 'cellar.aging.after');
						var drinkBy = lodash.get(self.wine, 'cellar.aging.by');

						var drinkText = [];

						if (drinkAfter){
							drinkText.push('Drink after ' + drinkAfter);
						}

						if (drinkBy){
							drinkText.push('Drink by ' + drinkBy);
						}

						if (drinkText.length > 0){
							$log.debug('Setting drink text', drinkText.join('\n'));

							label.setObjectText("DRINK", drinkText.join('\n'));
						} else {
                            label.setObjectText("DRINK", '');
						}

						label.setObjectText("ID", id);

						return label;
					});
				});
			});
		}

		function _newlineOn(chars, string){

			var count = 0;

			var str = '';

			var words = lodash.words(string);

			lodash.each(words, function(item){
				count += item.length;

				if (count > chars){
					str += '\n' + item;
					count = 0;
				} else {
					str += ' ' + item;
				}

			});

			return lodash.trim(str);
		}

		function printBigLabel(){

			var labelXml = '';

			var barcode = lodash.get(self.wine, 'cellar.ids.barcode');

			$log.debug('Printing big label for ' + self.wine.getFullName());

			var cb = null;

			if (barcode && barcode.length > 0){

				labelXml = "<?xml version=\"1.0\" encoding=\"utf-8\"?>" +
					"<DieCutLabel Version=\"8.0\" Units=\"twips\">" +
					"	<PaperOrientation>Landscape</PaperOrientation>" +
					"	<Id>Address</Id>" +
					"	<PaperName>30252 Address</PaperName>" +
					"	<DrawCommands>" +
					"		<RoundRectangle X=\"0\" Y=\"0\" Width=\"1581\" Height=\"5040\" Rx=\"270\" Ry=\"270\" />" +
					"	</DrawCommands>" +
					"	<ObjectInfo>" +
					"		<BarcodeObject>" +
					"			<Name>BARCODE</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>True</IsVariable>" +
					"			<Text></Text>" +
					"			<Type>UpcA</Type>" +
					"			<Size>Medium</Size>" +
					"			<TextPosition>Bottom</TextPosition>" +
					"			<TextFont Family=\"Arial\" Size=\"7.3125\" Bold=\"False\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"			<CheckSumFont Family=\"Arial\" Size=\"7.3125\" Bold=\"False\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"			<TextEmbedding>Full</TextEmbedding>" +
					"			<ECLevel>0</ECLevel>" +
					"			<HorizontalAlignment>Center</HorizontalAlignment>" +
					"			<QuietZonesPadding Left=\"0\" Top=\"0\" Right=\"0\" Bottom=\"0\" />" +
					"		</BarcodeObject>" +
					"		<Bounds X=\"331\" Y=\"680.31494140625\" Width=\"4440.47265625\" Height=\"765.708679199219\" />" +
					"	</ObjectInfo>" +
					"	<ObjectInfo>" +
					"		<TextObject>" +
					"			<Name>LABEL</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>True</IsVariable>" +
					"			<HorizontalAlignment>Center</HorizontalAlignment>" +
					"			<VerticalAlignment>Top</VerticalAlignment>" +
					"			<TextFitMode>ShrinkToFit</TextFitMode>" +
					"			<UseFullFontHeight>True</UseFullFontHeight>" +
					"			<Verticalized>False</Verticalized>" +
					"			<StyledText>" +
					"				<Element>" +
					"					<String></String>" +
					"					<Attributes>" +
					"						<Font Family=\"Arial\" Size=\"12\" Bold=\"True\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"						<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"					</Attributes>" +
					"				</Element>" +
					"			</StyledText>" +
					"		</TextObject>" +
					"		<Bounds X=\"331\" Y=\"328\" Width=\"4442\" Height=\"266.566925048828\" />" +
					"	</ObjectInfo>" +
					"	<ObjectInfo>" +
					"		<TextObject>" +
					"			<Name>ID</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>False</IsVariable>" +
					"			<HorizontalAlignment>Left</HorizontalAlignment>" +
					"			<VerticalAlignment>Middle</VerticalAlignment>" +
					"			<TextFitMode>ShrinkToFit</TextFitMode>" +
					"			<UseFullFontHeight>True</UseFullFontHeight>" +
					"			<Verticalized>False</Verticalized>" +
					"			<StyledText>" +
					"				<Element>" +
					"					<String></String>" +
					"					<Attributes>" +
					"						<Font Family=\"Arial\" Size=\"14\" Bold=\"False\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"						<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"					</Attributes>" +
					"				</Element>" +
					"			</StyledText>" +
					"		</TextObject>" +
					"		<Bounds X=\"331\" Y=\"73\" Width=\"3390\" Height=\"180\" />" +
					"	</ObjectInfo>" +
					"	<ObjectInfo>" +
					"		<TextObject>" +
					"			<Name>VINTAGE</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>False</IsVariable>" +
					"			<HorizontalAlignment>Right</HorizontalAlignment>" +
					"			<VerticalAlignment>Top</VerticalAlignment>" +
					"			<TextFitMode>ShrinkToFit</TextFitMode>" +
					"			<UseFullFontHeight>True</UseFullFontHeight>" +
					"			<Verticalized>False</Verticalized>" +
					"			<StyledText>" +
					"				<Element>" +
					"					<String></String>" +
					"					<Attributes>" +
					"						<Font Family=\"Arial\" Size=\"14\" Bold=\"False\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"						<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"					</Attributes>" +
					"				</Element>" +
					"			</StyledText>" +
					"		</TextObject>" +
					"		<Bounds X=\"3744\" Y=\"73\" Width=\"990\" Height=\"180\" />" +
					"	</ObjectInfo>" +
					"</DieCutLabel>";

				cb = function(label, id, barcode){

					var labelText = [
						lodash.get(self.wine, 'producer.name'),
						lodash.get(self.wine, 'name')
					];

					labelText = labelText.join(' ');

					$log.debug('Setting label text to: ', labelText);

					label.setObjectText("LABEL", labelText);

					var vintage = lodash.get(self.wine, 'vintage');

					if (vintage > 0){
						$log.debug('Setting vintage text to: ', vintage);
						label.setObjectText('VINTAGE', vintage + '');
					} else {
                        label.setObjectText('VINTAGE', '');
					}

					if (barcode.length > 0){
						$log.debug('Setting barcode to: ', barcode);

						label.setObjectText("BARCODE", barcode);
					} else {
                        label.setObjectText("BARCODE", '');
					}

					if (id){
						id = '#' + id;
					}

					label.setObjectText("ID", id);

					return label;
				};

			} else {

				labelXml = "<?xml version=\"1.0\" encoding=\"utf-8\"?>" +
					"<DieCutLabel Version=\"8.0\" Units=\"twips\">" +
					"	<PaperOrientation>Landscape</PaperOrientation>" +
					"	<Id>Address</Id>" +
					"	<PaperName>30252 Address</PaperName>" +
					"	<DrawCommands>" +
					"		<RoundRectangle X=\"0\" Y=\"0\" Width=\"1581\" Height=\"5040\" Rx=\"270\" Ry=\"270\" />" +
					"	</DrawCommands>" +
					"	<ObjectInfo>" +
					"		<TextObject>" +
					"			<Name>LABEL</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>True</IsVariable>" +
					"			<HorizontalAlignment>Center</HorizontalAlignment>" +
					"			<VerticalAlignment>Top</VerticalAlignment>" +
					"			<TextFitMode>ShrinkToFit</TextFitMode>" +
					"			<UseFullFontHeight>True</UseFullFontHeight>" +
					"			<Verticalized>False</Verticalized>" +
					"			<StyledText>" +
					"				<Element>" +
					"					<String></String>" +
					"					<Attributes>" +
					"						<Font Family=\"Arial\" Size=\"22\" Bold=\"False\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"						<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"					</Attributes>" +
					"				</Element>" +
					"			</StyledText>" +
					"		</TextObject>" +
					"		<Bounds X=\"331\" Y=\"868\" Width=\"4442\" Height=\"625\" />" +
					"	</ObjectInfo>" +
					"	<ObjectInfo>" +
					"		<TextObject>" +
					"			<Name>ID</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>False</IsVariable>" +
					"			<HorizontalAlignment>Left</HorizontalAlignment>" +
					"			<VerticalAlignment>Middle</VerticalAlignment>" +
					"			<TextFitMode>ShrinkToFit</TextFitMode>" +
					"			<UseFullFontHeight>True</UseFullFontHeight>" +
					"			<Verticalized>False</Verticalized>" +
					"			<StyledText>" +
					"				<Element>" +
					"					<String></String>" +
					"					<Attributes>" +
					"						<Font Family=\"Arial\" Size=\"14\" Bold=\"False\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"						<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"					</Attributes>" +
					"				</Element>" +
					"			</StyledText>" +
					"		</TextObject>" +
					"		<Bounds X=\"331\" Y=\"73\" Width=\"3390\" Height=\"180\" />" +
					"	</ObjectInfo>" +
					"	<ObjectInfo>" +
					"		<TextObject>" +
					"			<Name>PRODUCER</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>False</IsVariable>" +
					"			<HorizontalAlignment>Center</HorizontalAlignment>" +
					"			<VerticalAlignment>Middle</VerticalAlignment>" +
					"			<TextFitMode>ShrinkToFit</TextFitMode>" +
					"			<UseFullFontHeight>True</UseFullFontHeight>" +
					"			<Verticalized>False</Verticalized>" +
					"			<StyledText>" +
					"				<Element>" +
					"					<String></String>" +
					"					<Attributes>" +
					"						<Font Family=\"Arial\" Size=\"24\" Bold=\"True\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"						<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"					</Attributes>" +
					"				</Element>" +
					"			</StyledText>" +
					"		</TextObject>" +
					"		<Bounds X=\"331\" Y=\"331.2\" Width=\"4530\" Height=\"390\" />" +
					"	</ObjectInfo>" +
					"	<ObjectInfo>" +
					"		<TextObject>" +
					"			<Name>VINTAGE</Name>" +
					"			<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"			<BackColor Alpha=\"0\" Red=\"255\" Green=\"255\" Blue=\"255\" />" +
					"			<LinkedObjectName></LinkedObjectName>" +
					"			<Rotation>Rotation0</Rotation>" +
					"			<IsMirrored>False</IsMirrored>" +
					"			<IsVariable>False</IsVariable>" +
					"			<HorizontalAlignment>Right</HorizontalAlignment>" +
					"			<VerticalAlignment>Top</VerticalAlignment>" +
					"			<TextFitMode>ShrinkToFit</TextFitMode>" +
					"			<UseFullFontHeight>True</UseFullFontHeight>" +
					"			<Verticalized>False</Verticalized>" +
					"			<StyledText>" +
					"				<Element>" +
					"					<String></String>" +
					"					<Attributes>" +
					"						<Font Family=\"Arial\" Size=\"14\" Bold=\"False\" Italic=\"False\" Underline=\"False\" Strikeout=\"False\" />" +
					"						<ForeColor Alpha=\"255\" Red=\"0\" Green=\"0\" Blue=\"0\" />" +
					"					</Attributes>" +
					"				</Element>" +
					"			</StyledText>" +
					"		</TextObject>" +
					"		<Bounds X=\"3744\" Y=\"73\" Width=\"990\" Height=\"180\" />" +
					"	</ObjectInfo>" +
					"</DieCutLabel>";

				cb = function(label, id, barcode){
					var labelText = lodash.get(self.wine, 'name');
					var producer = lodash.get(self.wine, 'producer.name');
					var vintage = lodash.get(self.wine, 'vintage');

					$log.debug('Setting label text to: ', labelText);
					$log.debug('Setting producer text to: ', producer);

					label.setObjectText("LABEL", labelText);
					label.setObjectText("PRODUCER", producer);

					if (vintage > 0){
						$log.debug('Setting vintage text to: ', vintage);
						label.setObjectText('VINTAGE', vintage + '');
					} else {
                        label.setObjectText('VINTAGE', '');
					}

					if (id){
						id = '#' + id;
					}

					label.setObjectText("ID", id);

					return label;
				};
			}

			_printLabel(labelXml, cb);
		}

		function printSmallLabel(){

		}

		function _printLabel(labelXml, cb){

			var printerName = self.settings.selectedPrinter;

			$log.debug('Printing on ' + printerName);

			try {
				var printResult = _sendLabelToPrinter(labelXml, cb, printerName);

				if (printResult === false){
					self.error.message = 'Something went wrong. Please contact support if the issue persists.';
					return false;
				}

			} catch (err){
				Rollbar.Rollbar.error(err);
				$log.error('Error printing label', err);
				self.error.message = 'Error printing. Please install a DYMO printer or review our printing section on the Help screen.';
			}

		}

		function _sendLabelToPrinter(labelXml, cb, printerName){

			var label = $window.dymo.label.framework.openLabelXml(labelXml);

			var barcode = lodash.get(self.wine, 'cellar.ids.barcode');

			if (barcode && barcode.length === 12){
				// need to remove check digit
				$log.debug('Removing check digit.');
				$log.debug('Before', barcode);
				barcode = barcode.substr(0, barcode.length-1);
				$log.debug('After', barcode);
			}

			var id = lodash.get(self.wine, 'cellar.ids.custom');

			if (! id){
				id = lodash.get(self.wine, 'cellar.id');
			}

			// run callback
			label = cb(label, id.toString(), barcode);

			if (lodash.isNotEmptyOrNull(printerName)){

				$log.debug('Printing ' + self.settings.qty + ' labels.');

				return lodash.times(self.settings.qty, function(){
					label.print(printerName);
				});

			}

			return false;
		}
	}

})();
